











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {CompartilhamentoApp} from '@/model/resource/CompartilhamentoApp'
import {CompartilhamentoAppCollection} from '@/model/collection/CompartilhamentoAppCollection'
import {ListCompartilhamentoAppSchema} from '@/schema/resource/CompartilhamentoApp/ListCompartilhamentoAppSchema'
import {CsvCompartilhamentoAppSchema} from '@/schema/resource/CompartilhamentoApp/CsvCompartilhamentoAppSchema'

@Component
export default class ListCompartilhamentoAppView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListCompartilhamentoAppSchema()
  collection = new CompartilhamentoAppCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: CompartilhamentoApp) {
    Helper.pushByName('editCompartilhamentoApp', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new CompartilhamentoAppCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvCompartilhamentoApp()
    new CsvCompartilhamentoAppSchema().downloadCsv(csv.all())
  }
}
